import styled from "styled-components"

import { ReactComponent as IconArrowSmallUp } from "assets/svg/icon-arrow-small-up.svg"

export const Section = styled.section`
  width: 100%;
  padding: 24px;
  background: var(--surface-2);
  border-radius: 24px;
  margin-bottom: 24px;

  @media only screen and (max-width: 768px) {
    padding: 24px 16px;
  }
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  margin: 0;
  color: var(--text-primary);
`

export const CardsContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`

export const Column = styled.div<{ $hasBorder?: boolean }>`
  flex: 1 0 0;
  min-width: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  align-items: flex-start;
  ${({ $hasBorder }) => $hasBorder && `border-right: 1px solid var(--border-strong);`}
`

export const ChartOverlay = styled.div`
  position: absolute;
  left: 30px;
  right: 0;
  top: 0;
  bottom: 5px;
`

export const ChartFade = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, white, rgba(255, 255, 255, 0));
  pointer-events: none;
`

export const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-right: 100px;
  min-width: 0;
  width: 0;
  cursor: default;
`

export const Label = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: var(--text-muted);
  line-height: 16px;
  white-space: nowrap;
`

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ValueRow = styled.div`
  display: flex;
  align-items: baseline;
  cursor: default;
  position: relative;
  white-space: nowrap;
`

export const ValueText = styled.span`
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: var(--text-primary);
  opacity: 0.8;
  white-space: nowrap;
`

export const ValueExtra = styled.span`
  font-size: 15px;
  font-weight: 500;
  line-height: 32px;
  color: var(--text-primary);
  opacity: 0.8;
`

export const TooltipBox = styled.div<{ $visible: boolean }>`
  position: absolute;
  bottom: calc(100% + 6px);
  left: 0;
  white-space: nowrap;
  background: var(--surface-1);
  border: 1px solid var(--border-default);
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 400;
  color: var(--text-secondary);
  box-shadow:
    0px 12px 24px 0px rgba(148, 163, 184, 0.12),
    0px 1px 2px 0px rgba(226, 232, 240, 0.24);
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: none;
  z-index: 10;
  transition: opacity 0.15s;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const TooltipTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 4px;
`

export const TooltipLine = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: var(--text-secondary);
  line-height: 20px;
`

export const TrendRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const TrendBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`

export const TrendPercent = styled.span<{ $direction: "up" | "down" | "flat" }>`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ $direction }) => {
    if ($direction === "up") return "#22C55E"
    if ($direction === "down") return "#EF4444"
    return "#94a3b8"
  }};
`

export const ArrowIcon = styled(IconArrowSmallUp)<{ $direction: "up" | "down" }>`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transform: ${({ $direction }) => ($direction === "down" ? "rotate(180deg)" : "none")};

  path {
    fill: ${({ $direction }) => ($direction === "down" ? "#EF4444" : "#22C55E")};
  }
`

export const DaysText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #666c6c;
  line-height: 16px;
  white-space: nowrap;
`
